import { DEFAULT_PAGINATION_STATE } from '../../../common/constants'

export const state = {
  searchFilesPending: false,
  searchFilesResults: [],
  searchFilesResultsPagination: {},
  searchFilesAbortController: null,
  searchPageResultsPending: false,
  searchPageResults: [],
  searchPageResultsAggregations: {},
  searchPageResultsPagination: {},
  searchPageFilters: {},
  searchPageAppliedFilters: {},
  isRecentFilesSearch: false,
  searchPageResultsSnippetNote: false,
  searchPageAbortController: null,
  documentsToMove: {},
  duplicateLoading: false,
  lastMnemoAccessed: '',
  lastAccessTimestamp: 0,
  loading: false,
  shareLoading: false,
  moveLoading: false,
  deleteLoading: false,
  searchLoading: false,
  searchResults: [],
  versionsLoading: false,
  documents: {},
  fullTree: {},
  error: null,
  selectedDocuments: [],
  numberingEnabled: false,
  numberingError: null,
  patchNumberingPending: false,
  documentsPane: {
    isOpen: false,
    tab: '',
  },
  documentsTablePane: {
    documents: [],
    forcePmSelection: false,
    isOpen: false,
    previousDocument: null,
    tab: '',
    onCloseCallback: null,
    checklistFilesParent: null,
  },
  documentsVersioningPane: {
    documentVersions: [],
    documents: [],
    isOpen: false,
    removeVersionPending: false,
    tab: '',
  },
  searchModeEnabled: false,
  filters: [],
  filtersPaneIsOpen: false,
  uploadHiddenFilePendingIds: [],
  postFildersFromImanagePending: false,
  postFildersFromImanageError: null,
  postFildersAsVersionToImanagePending: false,
  postFildersAsVersionToImanageError: null,
  imanageHiddenFileImportPending: false,
  imanageHiddenFileImportError: null,
  updateAccessTimePending: false,
  updateAccessTimeError: null,
  postVersionFromImanagePending: false,
  postVersionFromImanageError: null,
  editDocumentNumberingPending: false,
  postRequestAuthorizationBiblePending: false,
  postMassFoldersPending: false,
  postMassFoldersError: null,
  getFolderPathPending: false,
  shareDocumentsIndexByEmailPending: false,
  movementSnackbarIsOpen: false,
  numberingSnackbarIsOpen: false,
  foldersTree: null,
  foldersById: {},
  getFoldersTreePending: false,
  wopiLockedFiles: [],
  checkWopiLockedFilesPending: false,
  paginatedDocumentsCurrentFolderId: 0,
  paginatedDocumentsPending: false,
  paginatedDocuments: [],
  documentsSorting: {
    sortBy: 'name',
    sortDir: 'ASC',
  },
  searchQuery: null,
  paginatedDocumentsFilters: [],
  documentsPagination: { ...DEFAULT_PAGINATION_STATE },
  paginatedDocumentsAbortController: null,
  childrenLoadingFolderIds: [],
}
